<ng-template #uploadProcess>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">Upload links for PO</div>
      <div class="modal-body">
        <div class="files-table-scroll">
          <table class="cl-table-data cl-table-data-light">
            <thead>
              <tr>
                <th class="cl-table-head">PO Item</th>
                <th class="cl-table-head">Upload Link</th>
              </tr>
            </thead>
            @if (loading() || uploadError()) {
              <tbody>
                <tr appLoadRow [state]="uploadState()" thing="upload links"></tr>
              </tbody>
            } @else {
              <tbody>
                @for (u of uploads; track u.text) {
                  <tr>
                    <td>{{ u.text }}</td>
                    <td>
                      @if (u.url) {
                        <a class="cl-a cl-a-external" [attr.href]="u.url" target="_blank">Open</a>
                      } @else {
                        <span class="cl-faded">Not permitted</span>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            }
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <span class="modal-footer-left"></span>
        <span class="modal-footer-center">
          <button type="button" class="btn cl-color-secondary it-ok"
                  (click)="this.dialog.closeAll()">
            <span>Close</span>
          </button>
        </span>
        <span class="modal-footer-right"></span>
      </div>
    </div>
  </div>
</ng-template>


<app-logo-area [breadcrumbs]="breadCrumbs()"></app-logo-area>
@let po = this.po();
@let org = this.organization();

<main>
  <app-headline-section
    [title]="po?.po_name ?? poName()"
  ></app-headline-section>
  <!-- PO actions only for a loaded PO: none on a PO that does not exist (VTK-3587), and none while po()
       is cleared for the next PO (VTK-3584) -- every action reads its id. -->
  @if (po) {
  <section class="cl-section cl-section-regular">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <p class="alert cl-alert-action">
            <a role="button" (click)="genUploads(); this.openDialog(uploadProcess)">
              Generate Upload Links
            </a>
            <a role="button" (click)="manageFiles()">
              Manage Output
            </a>

            @if ('contentplatform:workflow:Mutation/Publish' | isAllowed: 'contentplatform:poitem:input.po_name/' + po?.id: org) {
              <a role="button"
                 [class.cl-a-disabled]="finalizeInflight()"
                 [class.cl-a-spinner]="finalizeInflight()"
                 (click)="this.publish()">
                Finalize PO
              </a>
            }

            @if ('contentplatform:workflow:Mutation/Publish' | isAllowed: 'contentplatform:poitem:input.po_name/' + po?.id: org) {
              <a role="button"
                 [routerLink]="['/reports', org?.id ,  po?.id]">
                 <span class="cl-a-external">Delivery Reports</span>
              </a>
            }
          </p>
        </div>
      </div>
    </div>
  </section>
  }
  @if (po && po.finalize_process) {
    <section class="cl-section cl-section-regular">
      <div class="container">
        @let vtkData = finalizeVtkData();
        <div class="row">
          <div class="col-12">
            @if (po.finalize_process.state === 'SUCCESS') {
              <p class="alert cl-alert-check">
                {{ po.finalize_process.message }}
                @if (vtkData) {
                  &mdash; <a class="cl-a cl-a-external" target="_blank" rel="noopener noreferrer"
                     [href]="VTK_SERVER + '/#/o/' + vtkData.organization_urn + '/jobs/' + vtkData.vtk_job_id + '?as=' + organization()?.id">VTK Job</a>
                }
              </p>
            } @else if (po.finalize_process.state === 'FAILED') {
              <p class="alert cl-alert-danger" role="alert">
                {{ po.finalize_process.message }}
                @if (vtkData) {
                  &mdash; <a class="cl-a cl-a-external" target="_blank" rel="noopener noreferrer"
                     [href]="VTK_SERVER + '/#/o/' + vtkData.organization_urn + '/jobs/' + vtkData.vtk_job_id + '?as=' + organization()?.id">VTK Job</a>
                }
              </p>
            } @else {
              <p class="alert cl-alert-info" role="alert">
                {{ po.finalize_process.message }}
                @if (vtkData) {
                  &mdash; <a class="cl-a cl-a-external" target="_blank" rel="noopener noreferrer"
                     [href]="VTK_SERVER + '/#/o/' + vtkData.organization_urn + '/jobs/' + vtkData.vtk_job_id + '?as=' + organization()?.id">VTK Job</a>
                }
              </p>
            }
          </div>
        </div>
      </div>
    </section>
  }
  @let templates = vtkTemplates();
  <section class="cl-section cl-section-regular">

    <div class="container">
      <div class="row">
        <div class="col-12">
          <p class="cl-h5">Templates:
            @for (template of templates; track template; let i = $index) {
              <span>{{ template }}@if(i < templates.length - 1) {<span>, </span>}</span>
            }
          </p>
        </div>
      </div>
    </div>

  </section>
  <app-filter-section [all]="poitems()" [filtered]="poitems_filtered()" [formGroup]="filters">
    <form [formGroup]="filters" class="cl-form">
      <div class="row g-3">
        <div class="col mt-0">
          <label for="filter" class="form-label">Filter by title and filename</label>
          <input type="text" class="form-control" formControlName="t" id="filter" autofocus>
          <p class="valid-feedback">Filter terms are case-insensitive.</p>
        </div>
        <div class="col-3 mt-0">
          <label for="encode_state" class="form-label">Encode State</label>
          <select formControlName="e" class="form-select" id="encode_state">
            <option [ngValue]="null">All</option>
            <option [value]="'IN_PROGRESS'">In progress</option>
            <option [value]="'FAILED'">Failed</option>
            <option [value]="'SUCCESS'">Success</option>
          </select>
        </div>
        <div class="col-3 mt-0">
          <label for="publish_state" class="form-label">Publish State</label>
          <select formControlName="p" class="form-select" id="publish_state">
            <option [ngValue]="null">All</option>
            <option [value]="'IN_PROGRESS'">In progress</option>
            <option [value]="'FAILED'">Failed</option>
            <option [value]="'SUCCESS'">Success</option>
            <option [value]="'NOT_STARTED'">Not Started</option>
          </select>
        </div>
      </div>
    </form>
  </app-filter-section>@if (loadError()) {
  <section class="cl-section cl-section-regular">
    <div class="container"><p class="alert cl-alert-danger" role="alert">Could not load the encodes: {{ loadError() }}</p></div>
  </section>
}
<section class="cl-section cl-section-regular">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="cl-table-scroll">
            <table class="cl-table-data">
              <thead>
              <tr>
                <th class="cl-table-head cl-table-head-checkbox">
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" [checked]="checked()"
                           [indeterminate]="indeterminate()"
                           (change)="toggleAll()"/>
                  </div>
                </th>
                <th class="cl-table-head">Title</th>
                <th class="cl-table-head">Encode</th>
                <!-- Wide enough for the longest stage badge -->
                <th class="cl-table-head" style="min-width: 10rem">Publish</th>
                <th class="cl-table-head">Video</th>
                <th class="cl-table-head">Audio</th>
                <th class="cl-table-head">Subs</th>
                <th class="cl-table-head">CC</th>
                <th class="cl-table-head">Images</th>
                @if (hasMetadata()) {
                  <th class="cl-table-head">Metadata</th>
                }
                <th class="cl-table-head cl-th-links"></th>
              </tr>
              </thead>
              <tbody>
              @if (loading()) {
                <tr class="cl-tr-no-data">
                  <td colspan="100"><div class="cl-spinner">Loading ...<i class="fas fa-spinner fa-spin"></i></div></td>
                </tr>
              } @else {
                @if (poitems_filtered(); as poitems_filtered) {
                  @if (poitems(); as poitems) {
                    <tr>
                      <td>

                      </td>
                      @if (prefix$ | async; as parent) {
                        <td><a [routerLink]="['/o', org?.id, 'workflows',  po?.airline, parent]">..
                          (up)</a></td>
                      } @else {
                        <td><a [routerLink]="['/o', org?.id, 'workflows', po?.airline]">.. (up)</a>
                        </td>
                      }
                      <td class="cl-td-links" width="1%"></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      @if (hasMetadata()) {
                        <td></td>
                      }
                    </tr>
                    @if (poitems.length == 0) {
                      <tr class="cl-tr-no-data">
                        <td colspan="100">{{ notFound() ? 'PO ' + poName() + ' not found.' : 'This PO is empty.' }}</td>
                      </tr>
                    } @else if (poitems_filtered.length === 0) {
                      <tr class="cl-tr-no-data">
                        <td colspan="100">The selection is empty. Change the filter to see PO items.</td>
                      </tr>
                    }
                    @for (poitem of poitems_filtered; track poitem.id; let i = $index) {
                      <tr app-po-item-line
                          [poItem]="poitem"
                          [selected]="isSelected(poitem)"
                          (selectionChange)="toggleSelection(poitem)"
                          [displayMetadata]="hasMetadata()"></tr>
                    }
                  }
                }
              }
              </tbody>
            </table>
          </div>
          <!-- Outside .cl-table-scroll: its overflow makes it the sticky container, and it has no height
               limit, so a footer inside it scrolled away with the page (VTK-3627). -->
          @if (selectedCount() > 0) {
            <div class="batch-actions-footer" role="toolbar" aria-label="Batch actions">
              <!-- cl-spacing-box-tiny spaces the actions apart; inside the old <td class="cl-td-links"> that came from the td. -->
              <div class="cl-spacing-box-tiny">
                <i class="fas fa-share fa-rotate-270 cl-faded" aria-hidden="true"></i>
                @if (canBatchPublish()) {
                  <a class="cl-a-btn"
                     [class.cl-a-disabled]="batchPublishInflight() || batchRestartInflight()"
                     [class.cl-a-spinner]="batchPublishInflight()"
                     (click)="batchPublish()">Publish Selected ({{ selectedCount() }})</a>
                }
                <a class="cl-a-btn"
                   [class.cl-a-disabled]="batchPublishInflight() || batchRestartInflight()"
                   [class.cl-a-spinner]="batchRestartInflight()"
                   (click)="batchRestart()">Restart Selected ({{ selectedCount() }})</a>
                <a class="cl-a-btn"
                   (click)="clearSelection()">Clear Selection</a>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </section>
</main>
